const FalseCheck = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38647 9.79493L6.41999 12.8284C6.83004 13.2385 7.49486 13.2385 7.90491 12.8284L14.6134 6.11993C14.9281 5.80527 14.9281 5.29512 14.6134 4.98047C14.2988 4.66581 13.7886 4.66581 13.474 4.98046L7.8342 10.6202C7.4632 10.9912 6.8617 10.9912 6.4907 10.6202L4.52593 8.65546C4.21128 8.34081 3.70112 8.34081 3.38647 8.65546C3.07182 8.97012 3.07182 9.48027 3.38647 9.79493Z"
        fill="#A5A5A5"
        stroke="#A5A5A5"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export default FalseCheck;
